import MainHeading from "../typeComponents/MainHeading";
import TextBlock from "../typeComponents/TextBlock";
import Paragraph from "../typeComponents/Paragraph";
import { useFormFields, useMailChimpForm } from "use-mailchimp-form";

const JoinOurNewsletter = () => {
  const url =
    "https://curemontreal.us19.list-manage.com/subscribe/post?u=3d02597f68d20a7353233cdaf&amp;id=f686068adb&amp;f_id=003355e7f0";
  const { loading, error, success, message, handleSubmit } =
    useMailChimpForm(url);
  const { fields, handleFieldChange } = useFormFields({
    EMAIL: "",
    // FNAME: "",
    // LNAME: "",
    // MMERGE7: "",
  });

  return (
    <TextBlock>
      <MainHeading>Join Our Newsletter!</MainHeading>
      <Paragraph>
        We'd love for you to know what we're up to at CURE, especially if you're
        a Concordia student!
      </Paragraph>
      <Paragraph>
        Use this form to sign up for our newsletter! It's the best place to
        learn about CURE events, opportunities at CURE, our partner orgs, or
        around campus, and cool recipes we send!📈
      </Paragraph>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          handleSubmit(fields);
        }}
      >
        {/* The horizontal margins for the form are a little messed up right now as within the form, things are aligning to the left, but the input fields aren't aligning to the left so they're all staggered. 
        Also not sure if how I've laid out the <br> tags and the spacing between fields is ok? lmk! */}
        <label htmlFor="EMAIL">Email address: </label>
        <input
          id="EMAIL"
          type="email"
          value={fields.EMAIL}
          onChange={handleFieldChange}
          placeholder="example@mail.com"
        />{" "}
        {/* <br></br>
        <label htmlFor="FNAME">First name: </label>
        <input
          id="FNAME"
          type="text"
          value={fields.FNAME}
          onChange={handleFieldChange}
          placeholder="Jane"
        />{" "}
        <br></br>
        <label htmlFor="LNAME">Last name: </label>
        <input
          id="LNAME"
          type="text"
          value={fields.LNAME}
          onChange={handleFieldChange}
          placeholder="Doe"
        />{" "}
        <br></br> */}
        {/* Very uncertain as to what to put in value...
        In the html code MailChimp gives us, they simply put the text that has to go in there, whereas for the earlier ones, they put nothing. However, we are here using the fields object... 
        For the above input tags, it should just be the default value, not even what is being sent, so could it be that we don't actually need the fields object? 
        However, the handler function is called handle**Field**Change
        Is it being used to send info at all or is it just being used so we can set the defaults at the top? 
        
        Similar uncertainty with the name attribute, it's unclear to me if it's used by mailchimp or the handler function, as it does seem to be important for data in <select> tags...
        Thus, is it better to match the Mailchimp data stuff, or is a descriptive one better? 
        The test seemed to work on my end...
        
        Lastly, I don't like the spacing around the "You are a..." */}
        {/* Commenting out non-working people type fields for now
        <p>You are a...</p>
        <input
          id="MMERGE70" 
          type="radio"
          name="MMERGE7"
          value="Current/Recent Concordia Undergrad Student"
          onChange={handleFieldChange}
        /> <label htmlFor="MMERGE70">Current/Recent Concordia Undergrad Student</label>
        <br></br>
        <input
          id="MMERGE71"
          type="radio"
          name="MMERGE7"
          value="Current/Recent Concordia Grad Student"
          onChange={handleFieldChange}
        /> <label htmlFor="MMERGE71">Current/Recent Concordia Grad Student</label>
        <br></br>
        <input
          id="MMERGE72"
          type="radio"
          name="MMERGE7"
          value="Current/Recent Undergrad at another university"
          onChange={handleFieldChange}
        /> <label htmlFor="MMERGE72">Current/Recent Undergrad at another university</label>
        <br></br>
        <input
          id="MMERGE73"
          type="radio"
          name="MMERGE7"
          value="Current/Recent Grad at another university"
          onChange={handleFieldChange}
        /> <label htmlFor="MMERGE73">Current/Recent Grad at another university</label>
        <br></br>
        <input
          id="MMERGE74"
          type="radio"
          name="MMERGE7"
          value="Community Member"
          onChange={handleFieldChange}
        /> <label htmlFor="MMERGE74">Community Member</label>
        <br></br><br></br>
        */}
        {/* commenting out non-working}
        <label htmlFor="MMERGE3">Faculty/College (Concordia undergrads - optional) </label>
        <select id="MMERGE3">
          <option value=""></option>
          <option value="Faculty of Arts and Science">Faculty of Arts and Science</option>
          <option value="Gina Cody School of Engineering and Computer Science">Gina Cody School of Engineering and Computer Science</option>
          <option value="Faculty of Fine Arts">Faculty of Fine Arts</option>
          <option value="John Molson School of Business">John Molson School of Business</option>
          <option value="School of Community and Public Affairs">School of Community and Public Affairs</option>
          COMMENT There's a typo here in the Mailchimp stuff... COMMENT
          <option value="Simone de Beauvoire Institutre">Simone de Beauvoire Institute</option>
          <option value="Other School or College">Other School or College</option>
        </select> <br></br>

        <p>I would be interested in volunteering for CURE</p>
        <input 
          id="mce-group[2667]-2667-0"
          type="checkbox"
          name="group[2667][1]"
          value=""
        /> <label htmlFor="mce-group[2667]-2667-0">Yes, please contact me with volunteer opportunities</label>
        <br></br><br></br>
        */}
        <button type="submit" disabled={loading}>
          {loading ? "Subscribing..." : "Subscribe"}
        </button>
      </form>
      <br></br>
      <br></br>
      {loading ? <p>Submitting...</p> : <></>}
      {error ? <p>{message}</p> : <></>}
      {success ? <p>{message}</p> : <></>}
      <Paragraph>
        We never send more than one a month, we won't use your email for any
        other purposes. You can unsubscribe at any time.
      </Paragraph>
      <Paragraph>
        This currently works best in Chrome -- other browsers' tracking blockers
        might make it bug out. We're working on a fix!😅
      </Paragraph>
    </TextBlock>
  );
};
export default JoinOurNewsletter;
